import { IClientResponse } from "./client-response.interface";

export class ClientResponseModel<T> implements IClientResponse<T> {
    public isSuccess = false;
    public message = '';
    public data: T | null = null;
}